/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
// import { useEffect } from 'react';
import { connect } from 'react-redux';
import { confirmUser } from '../../store/User/userActions';
import { ROUTES } from '../../assets/constants/strings';
import AccountPagesWrapper from '../../components/Account/PageWrapper';
import { useParams, Redirect } from 'react-router-dom';
import ConfirmEmail from '../../components/Account/ConfirmEmail';
import './style.scoped.scss';

const ConfirmEmailPage = ({ loading, user, confirmUser }) => {
  const { userID, token } = useParams();

  useEffect(() => {
    if (!user && userID && token) confirmUser(userID, token);
  }, []);

  if (!userID || !token) return <Redirect to={ROUTES.LOGIN} />;

  return (
    <AccountPagesWrapper>
      <ConfirmEmail userId={userID} code={token} />
    </AccountPagesWrapper>
  );
};

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  user: state.user.user,
});

const mapDispatchToProps = { confirmUser };

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailPage);
